export default __webpack_public_path__ + "static/media/starter.53abf1b4.svg";